import { render, staticRenderFns } from "./ModalShowProfile.vue?vue&type=template&id=72019068&"
import script from "./ModalShowProfile.vue?vue&type=script&lang=ts&"
export * from "./ModalShowProfile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports